import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { CustomMaterialModule } from '../material-module/material.module';
import { RouterModule } from '@angular/router';
import { AnagraficheModule } from '../anagrafiche/anagrafiche.module';
import { MappaSopralluoghiComponent } from './mappa-sopralluoghi/mappa-sopralluoghi.component';
import { FiltroMappaComponent } from './mappa-sopralluoghi/filtro-mappa/filtro-mappa.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormControlsModule } from '../shared/custom-form-controls/custom-form-controls.module';
import { MatDialogModule } from '@angular/material/dialog';



@NgModule({
  declarations: [HomeComponent, MappaSopralluoghiComponent, FiltroMappaComponent],
  imports: [
    CommonModule,
    CustomMaterialModule,
    RouterModule,
    AnagraficheModule,
    FormsModule,
    ReactiveFormsModule,
    CustomFormControlsModule,
    MatDialogModule,
  ]
})
export class HomeModule { }
